// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#tns-item>img[data-v-4127c903]{padding-left:-100px}", ""]);
// Exports
module.exports = exports;
